<template>
  <span v-if ="status_id == 1" class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-gray-100 text-gray-800"> No iniciado </span>
  <span v-if ="status_id == 2" class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-yellow-100 text-yellow-800"> Iniciado </span>
  <span v-if ="status_id == 3" class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-indigo-100 text-indigo-800"> Finalizado </span>
  <span v-if ="status_id == 4" class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-red-100 text-white"> Cancelado </span>
</template>

<script>

export default {
  props: ["status_id"],
  data() {
    return {
      
    };
  },
};
</script>

